import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../slices/authSlice";
import { login, loginGoogleH } from "../../Network/ApiAxios";
import { FcGoogle } from "react-icons/fc";
import { useGoogleLogin } from "@react-oauth/google";
import { IoAlertCircleOutline } from "react-icons/io5";
import LoaderSignal from "../utils/loader/loader";

export default function Login(props) {

  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.auth);

  const [loadingEmail, setLoadingEmail] = useState(false);
  const [loadingGoogle, setLoadingGoogle] = useState(false);
  const [error, setError] = useState("");
  const [resultMsg, setResultMsg] = useState("");
  const [resultDone, setResultDone] = useState(false);

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoadingEmail(true);
    setResultDone(false);
    localStorage.removeItem("idToken");

    // collect form data
    const form = document.forms.loginForm.elements;
    const fullForm = {};
    for (let i = 0; i < form.length; i++) {
      if (form[i].name) {
        fullForm[form[i].name] = form[i].value;
      }
    }
    const { email, password } = fullForm;

    try {
      const response = await login(email, password);
      if (response.data.status === "Fail") {
        setResultMsg(response.data.message);
        setResultDone(true);
      } else {
        localStorage.setItem("idToken", response.data.idToken);
        dispatch(setUser({ ...response.data }));
      }
    } catch (err) {
      setResultMsg(err.response?.data?.message || "Login failed");
      setResultDone(true);
    } finally {
      setLoadingEmail(false);
    }
  };

  const handleGoogleSuccess = async ({ code }) => {
    setLoadingGoogle(true);
    setError("");
    localStorage.removeItem("idToken");
    try {
      const { status, data } = await loginGoogleH(code);
      if (status === "success") {
        localStorage.setItem("idToken", data.idToken);
        dispatch(setUser({ ...data }));
      } else {
        setError("Google Sign-In failed. Please try again.");
      }
    } catch (err) {
      setError(err.message || "Google Sign-In failed. Please try again.");
    } finally {
      setLoadingGoogle(false);
    }
  };

  const handleGoogleError = () => {
    setError("Google Sign-In failed. Please try again.");
  };

  const loginGoogle = useGoogleLogin({
    onSuccess: handleGoogleSuccess,
    onError: handleGoogleError,
    flow: "auth-code",
    scope: "openid email profile",
  });


  return (
    <div className="new-login">
         <section>
        {" "}
        {/* background spans */}
        {Array.from({ length: 260 }).map((_, i) => (
          <span key={i} />
        ))}
        <div className="signin">
          <form id="loginForm" onSubmit={handleLogin} autoComplete="off">
            <div className="content">
              <h2>Sign In</h2>
              <div className="form">
                <div className="inputBox">
                  <input type="text" id="email" name="email" required="" />{" "}
                  <i>Email</i>
                </div>
                <div className="inputBox">
                  <input
                    type="password"
                    id="password"
                    name="password"
                    required=""
                  />{" "}
                  <i>Password</i>
                </div>
                <div className="links">
                  {" "}
                  {/* <a href="#">Forgot Password</a> <a href="#">Signup</a> */}
                </div>

                <div className="inputBox">
                 {loadingEmail ? (
                    <LoaderSignal loader marginOff />
                  ) : (
                    <input
                      type="submit"
                      value="Login"
                      disabled={loadingEmail}
                    />
                  )}
                </div>
                <div className="inputBox">
                 {resultDone && (
                    <p style={{ color: "red", fontSize: "14px" }}>
                      {resultMsg}
                    </p>
                  )}
                </div>
              <button
                  type="button"
                  onClick={() => loginGoogle()}
                  disabled={loadingGoogle}
                  style={{
                      fontSize: "16px",
                      width: "fit-content",
                      padding: "15px 25px",
                      border: "none",
                      borderRadius: "15px",
                      backgroundColor: "#ffffff",
                      color: "white",
                      cursor: "pointer",
                      margin: "0 auto",
                    }}
                >
                  {loadingGoogle ? (
                    <div className="loader" />
                  ) : (
                    <FcGoogle />
                  )}
                </button>
          {error && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      lineHeight: "normal",
                      marginTop: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <IoAlertCircleOutline
                      fill="red"
                      style={{ fontSize: "14px" }}
                    />
                    {error}
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </section>
    </div>


    // <>
    //   <div className={loading ? "login loading" : "login"}>
    //     <header className="header">
    //       <span className="text">LOGIN</span>
    //       <span className="loader"></span>
    //     </header>
    //     <form
    //       className="form"
    //       id="loginForm"
    //       onSubmit={handleLogin}
    //       autoComplete="off"
    //     >
    //       <input
    //         type="text"
    //         id="email"
    //         name="email"
    //         className="input"
    //         placeholder=" Email"
    //       />
    //       <input
    //         type="password"
    //         id="password"
    //         name="password"
    //         className="input"
    //         placeholder="Password"
    //       />
    //       <button class="btn__log" type="submit"></button>
    //     </form>
    //   </div>
    //   {resultDone ? <Popups text={resultMsg} left={50} /> : <div></div>}
    // </>

    // <div className="container-login">
    //   <div className="screen">
    //     <div className="screen__content">
    //       <form
    //         className="login"
    //         id="loginForm"
    //         onSubmit={handleLogin}
    //         autoComplete="off"
    //       >
    //         <div className="login__field">
    //           <i className="login__icon fas fa-user"></i>
    //           <input
    //             type="text"
    //             id="email"
    //             name="email"
    //             className="login__input"
    //             value="fathi.sulieman34@gmail.com"
    //             placeholder="User name / Email"
    //           />
    //         </div>
    //         <div className="login__field">
    //           <i className="login__icon fas fa-lock"></i>
    //           <input
    //             type="password"
    //             id="password"
    //             name="password"
    //             value="password"
    //             className="login__input"
    //             placeholder="Password"
    //           />
    //         </div>
    //         <button className="button login__submit" type="submit">
    //           <span className="button__text">Log In Now</span>
    //           <i className="button__icon fas fa-chevron-right"></i>
    //         </button>
    //       </form>
    //       <div className="social-login">
    //         {/* <h3>log in via</h3> */}
    //         {/* <div className="social-icons">
    //             <a href="#" className="social-login__icon fab fa-instagram"></a>
    //             <a href="#" className="social-login__icon fab fa-facebook"></a>
    //             <a href="#" className="social-login__icon fab fa-twitter"></a>
    //           </div> */}
    //       </div>
    //     </div>
    //     <div className="screen__background">
    //       <span className="screen__background__shape screen__background__shape4"></span>
    //       <span className="screen__background__shape screen__background__shape3"></span>
    //       <span className="screen__background__shape screen__background__shape2"></span>
    //       <span className="screen__background__shape screen__background__shape1"></span>
    //     </div>
    //   </div>
    // </div>
  );
}
